export const menuTypeEnum = {
  orderList: 1
}